import { useAppContext } from "../../context/AppContext";
import { ButtonsTrans } from "../../utils/translations";
import ActionToggleButton from "./ActionToggleButton";

const containerStyles = {
  pill: {
    active: "bg-green-700 border-green-700 text-white shadow-sm",
    inactive:
      "bg-green-50 border-green-200 text-green-700 hover:bg-green-700/90 hover:border-green-700/90 hover:text-white",
  },
  soft: {
    active: "bg-green-700/90 border-green-700/80 text-white",
    inactive:
      "bg-green-700/10 border-green-700/20 text-green-800 hover:bg-green-700/85 hover:border-green-700/85 hover:text-white",
  },
  outline: {
    active: "bg-green-700 border-green-700 text-white",
    inactive:
      "bg-white border-green-700/40 text-green-700 hover:bg-green-700 hover:border-green-700 hover:text-white",
  },
  minimal: {
    active: "bg-green-700 border-green-700 text-white",
    inactive:
      "bg-transparent border-green-700/50 text-green-700 hover:bg-green-700/10 hover:border-green-700",
  },
  elevated: {
    active: "bg-green-700 border-green-700 text-white shadow-md",
    inactive:
      "bg-green-50 border-green-100 text-green-700 shadow-sm hover:bg-green-700/90 hover:border-green-700/90 hover:text-white hover:shadow-md",
  },
};

export default function MarkAsCompleteButton({
  isComplete,
  toggleComplete,
  variant = "elevated",
  className = "",
  labelClassName = "",
  activeIconClassName = "",
  inactiveIconClassName = "",
}) {
  const { language } = useAppContext();

  return (
    <ActionToggleButton
      isActive={isComplete}
      onClick={toggleComplete}
      activeLabel={ButtonsTrans[language].complete}
      inactiveLabel={ButtonsTrans[language].markAsComplete}
      activeIcon={(
        <svg
          className={`mr-2 h-5 w-5 text-white ${activeIconClassName}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M5.5 12.5l4 4 9-9"
          />
        </svg>
      )}
      inactiveIcon={(
        <svg
          className={`mr-2 h-5 w-5 text-green-700 ${inactiveIconClassName}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75l2.25 2.25L15 11.25m6 1.5a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      )}
      variant={variant}
      stylesByVariant={containerStyles}
      focusRingClass="focus-visible:ring-green-700/30"
      className={className}
      labelClassName={labelClassName}
    />
  );
}
